import api from './api';

export const listTimetables = async (params = {}) => {
  const { data } = await api.get('/timetables', { params });
  return data;
};

export const createTimetable = async (payload) => {
  const { data } = await api.post('/timetables', payload);
  return data;
};

export const generateSessions = async (id, payload) => {
  const { data } = await api.post(`/timetables/${id}/generate-sessions`, payload);
  return data;
};

export default {
  listTimetables,
  createTimetable,
  generateSessions,
};
